import React from "react";
import { Modal } from "antd";
import { convertFirebaseTimestampToDateTimeString } from "../../../utils/functions/javaScriptHelper";
import GALKButton from "../../common/component/button";
import "./eventDetailsModal.css";

const EventDetailsModal = ({ event, modalCloseHandler }) => {
	const { title, allDay, extendedProps } = event;
	const { description, meetingUrl, startDateTimeStamp, endDateTimeStamp } =
		extendedProps;

	return (
		<Modal
			title={title}
			visible={true}
			width={680}
			// onOk={modalCloseHandler}
			onCancel={modalCloseHandler}
			footer={null}
		>
			<div className="event_details_modal_container">
				<div className="event_details_modal_container_body">
					<div className="row">
						<div className="title">Date: </div>
						<div className="description">
							{convertFirebaseTimestampToDateTimeString(
								startDateTimeStamp,
								"dd/mm/yyyy"
							)}
						</div>
					</div>

					<div className="row">
						<div className="title">Time: </div>
						<div className="description">
							{allDay
								? `All Day Event starting from ${convertFirebaseTimestampToDateTimeString(
										startDateTimeStamp,
										"hh:mm"
								  )}`
								: `${convertFirebaseTimestampToDateTimeString(
										startDateTimeStamp,
										"hh:mm"
								  )} - ${convertFirebaseTimestampToDateTimeString(
										endDateTimeStamp,
										"hh:mm"
								  )}`}
						</div>
					</div>

					<div className="row">
						<div className="title">Description: </div>
						<div className="description">{description}</div>
					</div>

					<div className="row">
						<div className="title">ZOOM URL: </div>
						<div className="description link">{meetingUrl}</div>
					</div>
				</div>

				<div className="event_details_modal_container_footer">
					<GALKButton type="primary" width={200} onClick={modalCloseHandler}>
						Ok
					</GALKButton>
				</div>
			</div>
		</Modal>
	);
};

export default EventDetailsModal;
